(()=>{'use strict';
const C=window.SDPC;if(!C||C.initReady)return;C.initReady=true;
const{$,$$,R,esc,toast}=C;
let predictiveTimer=null,predictiveController=null,predictiveSequence=0;

document.addEventListener('click',async e=>{
  const sub=e.target.closest('[data-mobile-submenu-toggle]');
  if(sub){e.preventDefault();sub.closest('.sd-mobile-menu__item')?.classList.toggle('is-open');return}
  const mega=e.target.closest('[data-mega-trigger]');
  if(mega){e.preventDefault();mega.closest('.sd-header__nav-item')?.classList.toggle('is-open');return}
  const copy=e.target.closest('[data-copy-code]');
  if(copy){
    e.preventDefault();e.stopImmediatePropagation();
    const code=copy.dataset.copyCode||'';
    try{await navigator.clipboard.writeText(code);copy.textContent='COPIED';toast('Coupon copied')}catch(_){toast(code)}
  }
},true);

document.addEventListener('input',e=>{
  const input=e.target.closest('[data-predictive-input]');if(!input)return;
  const host=input.closest('[data-drawer-name="search"]')||document;
  const results=$('[data-predictive-results]',host);if(!results)return;
  const query=input.value.trim();
  clearTimeout(predictiveTimer);
  predictiveController?.abort();
  predictiveController=null;
  const sequence=++predictiveSequence;
  if(query.length<2){results.innerHTML='';results.removeAttribute('aria-busy');return}
  results.setAttribute('aria-busy','true');
  predictiveTimer=setTimeout(async()=>{
    predictiveController=new AbortController();
    try{
      const url=`${R.predictiveSearch||'/search/suggest.json'}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`;
      const response=await fetch(url,{headers:{Accept:'application/json'},signal:predictiveController.signal});
      if(!response.ok)throw Error('Search unavailable');
      const json=await response.json();
      if(sequence!==predictiveSequence)return;
      const products=json.resources?.results?.products||[];
      results.innerHTML=products.map(product=>{
        const image=typeof product.image==='string'?product.image:(product.image?.url||'');
        const imageMarkup=image?`<img src="${esc(image)}${image.includes('?')?'&':'?'}width=320" alt="${esc(product.title)}" loading="lazy">`:'';
        return`<a class="sd-predictive-card" href="${esc(product.url)}">${imageMarkup}<span>${esc(product.title)}</span></a>`;
      }).join('');
    }catch(error){if(error.name!=='AbortError'&&sequence===predictiveSequence)results.innerHTML=''}
    finally{if(sequence===predictiveSequence)results.removeAttribute('aria-busy')}
  },220);
},true);

const countdowns=(scope=document)=>$$('[data-countdown]',scope).forEach(r=>{
  if(r.dataset.sdpc)return;r.dataset.sdpc='1';
  const end=new Date(r.dataset.countdown).getTime();if(!end)return;
  let timer=null;
  const tick=()=>{
    const d=end-Date.now();
    if(d<=0){r.textContent=r.dataset.expiredText||'DROP ENDED';if(timer)clearInterval(timer);return}
    const day=Math.floor(d/86400000),h=Math.floor(d/3600000)%24,m=Math.floor(d/60000)%60,s=Math.floor(d/1000)%60;
    r.textContent=`${day}D ${String(h).padStart(2,'0')}H ${String(m).padStart(2,'0')}M ${String(s).padStart(2,'0')}S`;
  };
  tick();timer=setInterval(tick,1000);
});

const init=(scope=document)=>{
  C.initProduct?.(scope);
  countdowns(scope);
  $$('[data-drawer-name]',scope).forEach(d=>{if(!d.classList.contains('is-open'))d.setAttribute('aria-hidden','true')});
  const h=$('[data-header-wrap]');
  if(h&&!h.dataset.sdpc){
    h.dataset.sdpc='1';
    const run=()=>h.classList.toggle('is-scrolled',scrollY>16);
    run();addEventListener('scroll',run,{passive:true});
  }
  document.documentElement.dataset.sdProductCore='3';
};
const boot=()=>{init(document);C.initCart?.()};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
document.addEventListener('shopify:section:load',e=>setTimeout(()=>init(e.target),0));
document.addEventListener('shopify:section:unload',e=>{
  const owner=e.target?.id;if(!owner)return;
  $$('[data-product-lightbox]',document.body).filter(x=>x.dataset.owner===owner).forEach(x=>{C.closeGallery?.();x.remove()});
});
})();
